import styled from "styled-components";
import { StyledLineProps } from "../../interfaces/MobileMenuInterface";

export const MobileButton = styled.button`
  display: none;
  background: transparent;
  z-index: 20;
  border-radius: 0.5rem;
  width: 1.75rem;
  min-width: 1.75rem;
  height: 2rem;
  flex-direction: column;
  align-items: flex-end;
  padding: 0.25rem;
  outline: none;
  border: none;
  justify-content: space-evenly;

  @media (max-width: 1024px) {
    display: flex;
  }
`;

export const StyledLineOne = styled.span<StyledLineProps>`
  height: 0.125rem;
  width: 1.25rem;
  display: block;
  background-color: #fff;
  border-radius: 0.5rem;
  transition: all 0.5s ease;
  position: ${({ showMenu }) => (showMenu ? "absolute" : "relative")};
  transform: ${({ showMenu }) => (showMenu ? "rotate(45deg)" : "rotate(0deg)")};
`;

export const StyledLineSecond = styled.span<StyledLineProps>`
  height: 0.125rem;
  display: block;
  background-color: #fff;
  border-radius: 0.5rem;
  transition: all 0.5s ease;
  width: ${({ showMenu }) => (showMenu ? "20px" : "20px")};
  position: ${({ showMenu }) => (showMenu ? "absolute" : "relative")};
  transform: ${({ showMenu }) =>
    showMenu ? "rotate(135deg)" : "rotate(0deg)"};
`;
